import API from 'services/api.js';
import {
	URL_GET_SESSION_IDS,
	URL_GET_SESSION_WEIGHERS,
} from 'services/urls.js';
import {
	actionSetMessage,
	actionResetMessages,
} from 'components/messages/actions.js';

export const SET_SESSION = 'SET_SESSION';
export const SET_SESSION_IDS = 'SET_SESSION_IDS';
export const RESET_SESSION_IDS = 'RESET_SESSION_IDS';

// Sync Action

export const actionSetSession = (data) => {
	return {
		type: SET_SESSION,
		data,
	};
};

export const actionFetchSessionIds = (
	clientId,
	includeYardWeights,
	setSessionLoading
) => {
	return (dispatch) => {
		dispatch(actionResetMessages());
		const params = {
			params: {
				clientId: clientId,
				...(includeYardWeights ? { includeYardWeights: 1 } : {}),
			},
		};
		return API.get(URL_GET_SESSION_IDS, params)
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log('error', error);
				dispatch(actionSetMessage("Error fetching Session ID's: " + error));
			})
			.then((resp) => {
				dispatch(actionFetchSessionIdsSuccess(resp));
				setSessionLoading(false);
			});
	};
};

export const actionFetchSessionIdsSuccess = (data) => {
	return {
		type: SET_SESSION_IDS,
		data,
	};
};

export const actionResetSessionIds = () => {
	return { type: RESET_SESSION_IDS };
};
